import { render, staticRenderFns } from "./AddLessee.vue?vue&type=template&id=b20f2f5c&scoped=true&"
import script from "./AddLessee.vue?vue&type=script&lang=js&"
export * from "./AddLessee.vue?vue&type=script&lang=js&"
import style0 from "./AddLessee.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddLessee.vue?vue&type=style&index=1&id=b20f2f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f2f5c",
  null
  
)

export default component.exports